export default {
  API_URL: import.meta.env.VITE_API_URL ?? "https://api.medflyt.com",
};
